import styled from 'styled-components';
import CalenderGreySvg from '../../assets/mytrips/calenderGrey.svg';

const CalenderGreyIcon = styled(CalenderGreySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CalenderGreyIcon;
